<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个组织机构</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%"
        @selection-change="handleSelectionChange" :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="code" label="组织编码" width="120"></el-table-column>
        <el-table-column prop="name" label="组织名称" min-width="130"></el-table-column>
        <el-table-column prop="hospitalId" label="医院CAP" min-width="130"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.updateTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" min-width="80" show-overflow-tooltip
          :formatter="formatState"></el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
              @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用"
              }}</el-button>
                <el-button  type="text" v-preventReClick v-if="tableAcl.indexOf('Setting') != -1"
              @click="handleParameterSettings(scope.row)" class="margin-left20 color-blue">参数</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '组织'" :visible.sync="open" :center="true" width="500px" :before-close="cancel"
        :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="组织编码" prop="code">
            <el-input v-model="form.code" :disabled="editMode && isEdit" placeholder="请填写组织编码"></el-input>
          </el-form-item>
          <el-form-item label="组织名称" prop="name">
            <el-input v-model="form.name" :disabled="!editMode" placeholder="请填写组织名称"></el-input>
          </el-form-item>
          <el-form-item label="医院CAP" prop="hospitalId">
            <el-input v-model="form.hospitalId" :disabled="!editMode" placeholder="请填写医院CAP"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" :disabled="!editMode" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="state">
            <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4"
              :active-value="1" :inactive-value="0">
            </el-switch>
            <span v-if="form.state">已启用</span>
            <span v-else>已禁用</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确
            定</my-button>
        </div>
      </el-dialog>
    </div>

    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <!-- 参数弹窗 -->
    <el-dialog title="参数设置" :visible.sync="parameterSettingsOpen" :center="true" width="70%" 
      :before-close="parameterSettingsCancel" :close-on-click-modal="false">
      <div style="margin:20px 0; display:flex; align-items:center;">
        <div>
            机构：{{ userInfo.orgInfos[0].name }}
        </div>
        <div style=" margin-left:20px; width:200px">
          <el-input type="text" v-model="formSettingQuery.keyWord" placeholder="请输入参数键" @keyup.enter.native="getHandleParameterSettings"></el-input>
        </div> 

      </div>
      <el-table border row-key="id" :data="formSetting"  style="width: 100%"
        :header-cell-style="{ background: '#DDEBFF' }" max-height="400px">
        <el-table-column label="应用" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.appType==1?'工作台':
                scope.row.appType==2?'资产':
                scope.row.appType==3?'耗材':'药品'
          }}
          </template>
        </el-table-column>
        <el-table-column  label="参数类型" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.category==1?'业务参数':'系统参数' }}
          </template>
        </el-table-column>
        <el-table-column prop="businessModule" label="业务模块" min-width="100"></el-table-column>
        <el-table-column prop="key" label="参数键" min-width="130"></el-table-column>
        <el-table-column prop="value" label="参数值" min-width="130">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{  scope.row.value }}</span>
            <el-input v-if="scope.row.isEdit" v-model="scope.row.value" placeholder="请输入参数值"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="参数说明" :show-overflow-tooltip="true" min-width="240"></el-table-column>
         <el-table-column prop="createdTime" label="创建时间" min-width="150">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </div>
            
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-if="!scope.row.isEdit" v-preventReClick @click="handleParameterSettingsUpdate(scope.row,'edit')" class="color-blue">编辑</el-button>
            <el-button type="text" v-if="scope.row.isEdit" v-preventReClick @click="handleParameterSettingsCancel(scope.row)" class="color-blue">取消</el-button>
            <el-button type="text" v-if="scope.row.isEdit" v-preventReClick @click="handleParameterSettingsUpdate(scope.row,'save')" class="color-blue">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
     
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetOrgInfos, SaveOrgInfo, UpdateOrgInfoState,UpdateOrgInfoSetting,GetOrgInfoSettings } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  mixins: [GetDataMixin],
  data() {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出编辑框
      open: false,
      editMode: false,
      isEdit: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        code: [
          {
            required: true,
            message: "请输入组织编码",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请选择组织名称",
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
      },
      cancelButtonText: "禁用",
      parameterSettingsOpen: false,
      formSetting:[],
      formSettingQuery:{
       keyWord:''
      }
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0 ? "启用" : "禁用";
    },
    // 获取列表
    getData() {
      GetOrgInfos(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    formatState(row, column) {
      return row.state === 0 ? "禁用" : "启用";
    },
    // 新建
    handleAdd() {
      this.open = true;
      this.resetForm();
      this.editMode = true;
      this.title = "新建";
    },
    handleInfo(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate(row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = true;
      this.isEdit = true;
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveOrgInfo(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => { });
      });
    },
    resetForm() {
      this.form = {
        name: "",
        state: 1,
        oneLevelWarehouseIdArr: [],
        oneLevelWarehouseIds: "",
        orgCode: sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel() {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.isEdit = false
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.isEdit = false
        this.open = false;
      }
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete(row) {
      let state = 0;
      let id = 0;
      if (row && row.id) {
        id = row.id;
        state = row.state == 1 ? 0 : 1;
      }
      console.log(state, "state");
      this.$my_confirm(
        state == 0
          ? "确认禁用当前组织机构吗" //"当前科室关联的有资产，确定仍然要禁用吗？"
          : "确认启用当前组织机构吗",
        "提示",
        {
          type: "warning",
        }
      )
        .then(() => {
          return UpdateOrgInfoState({
            id,
            state,
          });
        })
        .then(() => {
          this.$my_message(`操作成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset() {
      this.query = {
        name: "",
        state: "",
        pageIndex: 1,
        pageSize: 10,
        orgCode: sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    deptChange(val) {
      this.form.parentId = val;
    },
    userChange(val) {
      this.form.leader = val;
    },
    warehouseChange(arr) {
      this.form.oneLevelWarehouseIds = arr.join(";");
    },
    getHandleParameterSettings(){
      this.formSettingQuery.id = this.formSettingQuery.orgInfoId
      this.handleParameterSettings( this.formSettingQuery)
    },
    handleParameterSettings(row){
      this.parameterSettingsOpen = true;
      this.formSettingQuery.orgInfoId = row.id
      let query = this.formSettingQuery
      let data = {
        ...query,
        orgInfoId: row.id,
        pageIndex: 1,
        pageSize: 30,
      }
      GetOrgInfoSettings(data).then(res => {
        this.formSetting = res.returnData.data;
      })
    },
    parameterSettingsCancel(){
      this.formSettingQuery = {
        orgInfoId: '',
        keyWord: '',
      }
      this.parameterSettingsOpen = false;
    },
    handleParameterSettingsUpdate(row,type){
      if(type== 'edit'){
        this.$set(row,'isEdit', true)
      }else{  
        UpdateOrgInfoSetting(row).then(res=>{
          this.$my_message(`执行成功`, "success");
          this.$set(row,'isEdit', false)
        })
      }
    },handleParameterSettingsCancel(row){
       this.$set(row,'isEdit', false)
    }
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
